import { render, staticRenderFns } from "./MarkersList.vue?vue&type=template&id=54de79cc"
import script from "./MarkersList.vue?vue&type=script&lang=js"
export * from "./MarkersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports